import * as actionType      from "./Action_Type";
import createBrowserHistory from "history/createBrowserHistory";
import { CALL_API }         from "../Middlewares/api";
import * as SGUri           from "../Utils/PagesSwitch.js";
import { URL_RECOVER_CONVALIDATE_TOKEN, URL_RECOVER_SET_PASSWORD } from "../Utils/Strings/URL.js";


export function recoverCredentials(email){
    return {
        [CALL_API]: {
            endpoint: "/Account/RecoverPassword?Email="+email,
            authenticated: true,
            types: [
                actionType.SERVICE_RECOVER_CREDENTIALS_REQUEST,
                actionType.SERVICE_RECOVER_CREDENTIALS_SUCCESS,
                actionType.SERVICE_RECOVER_CREDENTIALS_ERROR
            ]
        }
    }
}

export const convalidateToken = (Token) => {
  let config = {
        method  : 'GET',
        headers : { "Content-Type": "application/json" },
    };
    return dispatch => {
      dispatch(convalidate_request());

      if(Token == null)
        return dispatch(convalidate_error("Token Not Found"));

      return fetch(URL_RECOVER_CONVALIDATE_TOKEN+"?Token="+Token, config)
        .then(response =>
          response.json().then(result => ({ result, response }))
        )
        .then(({ result, response }) => {
          if (!response.ok || !result.Data) {
            return Promise.reject(result);
          } else {
            dispatch(convalidate_success(result));
          }
        })
        .catch(err => {
            dispatch(convalidate_error(err.Message));
          }
        );
    };
};

//LOGOUT
export const convalidate_request = () => ({
  type       : actionType.SERVICE_RECOVER_VALIDATION_TOKEN_REQUEST,
  isFetching : true
});
export const convalidate_success = () => ({
  type: actionType.SERVICE_RECOVER_VALIDATION_TOKEN_SUCCESS,
  isFetching      : false
});
export const convalidate_error = (error) => ({
  type         : actionType.SERVICE_RECOVER_VALIDATION_TOKEN_ERROR,
  isFetching   : false,
  error
});


export const recoverSetPassword = (Token, Password, ConfermaPassword) => {
    var obj = {
      Token : Token,
      Password : Password,
      ConfirmPassword : ConfermaPassword
    };

    
    let config = {
        method  : 'POST',
        headers : { Accept: 'application/json', "Content-Type": "application/json" },
        body    : JSON.stringify(SGUri.serializeParametersPOST(obj))
    };

    
    return dispatch => {
      dispatch(convalidate_request());

      if(Token == null)
        return dispatch(convalidate_error("Token Not Found"));

      return fetch(URL_RECOVER_SET_PASSWORD, config)
        .then(response =>
          response.json().then(result => ({ result, response }))
        )
        .then(({ result, response }) => {
          if (!response.ok || !result.Data) {
            return Promise.reject(result);
          } else {
            dispatch(convalidate_success(result));
          }
        })
        .catch(err => {
            dispatch(convalidate_error(err.Message));
          }
        );
    };
}


// WEBPACK FOOTER //
// ./src/Actions/Action_ServiceRequest_RecuperaCredenziali.js